import React from 'react';
import { useLocation,useParams  } from 'react-router-dom';

import "./welcomeMessage.scss";
import { t } from 'i18next';
const WelcomeMessage = (props) => {
  const location = useLocation();
  let {page}=useParams() 
  return (
    <section className="welcome-message">
      {(location.pathname === '/dashboard/assistants'||location.pathname === `/users/${page}` )&& <div className="msg-title">
      {t("assistants")}
      </div>}
      {location.pathname === '/dashboard/overview' && <div className="msg-title">
        {t("overview")}
      </div>}
      {location.pathname === '/categories' && <div className="msg-title">
        {t("categorymgn")}
      </div>}
      {location.pathname === '/report' && <div className="msg-title">
        {t("report")}
      </div>}
      {location.pathname === '/manageusers' && <div className="msg-title">
        {t("manageUsers")}
      </div>}
      {props?.title && <div className="msg-title">
        {props?.title}
      </div>}
    </section>
  );
};

export default WelcomeMessage;
